/* Roots Nutrition — Minority Health anatomy diagram
   Wires hotspot clicks, woman/man toggle, deep-link hash, print, share,
   plus mobile bottom-sheet open/close. */
(function() {
  function init(root) {
    if (root.dataset.mhInit === '1') return;
    root.dataset.mhInit = '1';

    var panel = root.querySelector('[data-panel]');
    var backdrop = root.querySelector('[data-backdrop]');
    var panelCloseBtn = root.querySelector('[data-panel-close]');
    var toast = root.querySelector('[data-toast]');
    var bodyToggleBtns = root.querySelectorAll('[data-body-switch]');
    var hotspots = root.querySelectorAll('.mh-anatomy-spot');
    var legendBtns = root.querySelectorAll('.mh-anatomy-legend-btn');
    var panelCards = root.querySelectorAll('[data-panel-card]');
    var bodyPanes = root.querySelectorAll('[data-body-pane]');

    var currentBody = root.dataset.defaultBody || 'woman';
    var currentIdx = 0;

    function applyHotspotPositions() {
      Array.prototype.forEach.call(hotspots, function(spot) {
        var l = spot.getAttribute('data-pos-' + currentBody + '-left');
        var t = spot.getAttribute('data-pos-' + currentBody + '-top');
        if (l) spot.style.left = l;
        if (t) spot.style.top = t;
      });
    }

    function showForGender() {
      Array.prototype.forEach.call(hotspots, function(spot) {
        var g = spot.getAttribute('data-gender') || 'both';
        spot.hidden = (g !== 'both' && g !== currentBody);
      });
      Array.prototype.forEach.call(legendBtns, function(btn) {
        var g = btn.getAttribute('data-gender') || 'both';
        btn.hidden = (g !== 'both' && g !== currentBody);
      });
      var allCards = Array.prototype.slice.call(panelCards);
      var activeCard = allCards[currentIdx];
      if (activeCard) {
        var ag = activeCard.getAttribute('data-gender') || 'both';
        if (ag !== 'both' && ag !== currentBody) {
          for (var i = 0; i < allCards.length; i++) {
            var cg = allCards[i].getAttribute('data-gender') || 'both';
            if (cg === 'both' || cg === currentBody) { currentIdx = i; break; }
          }
        }
      }
    }

    function setActive(idx) {
      currentIdx = idx;
      Array.prototype.forEach.call(hotspots, function(s, i) {
        s.classList.toggle('is-active', i === idx);
      });
      Array.prototype.forEach.call(legendBtns, function(b, i) {
        b.classList.toggle('is-active', i === idx);
      });
      Array.prototype.forEach.call(panelCards, function(c, i) {
        c.classList.toggle('is-active', i === idx);
      });
    }

    function openPanel(idx) {
      setActive(idx);
      if (panel) panel.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
    }

    function closePanel() {
      if (panel) panel.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
    }

    function switchBody(key) {
      currentBody = key;
      Array.prototype.forEach.call(bodyToggleBtns, function(b) {
        b.classList.toggle('is-active', b.getAttribute('data-body-switch') === key);
      });
      Array.prototype.forEach.call(bodyPanes, function(p) {
        p.hidden = (p.getAttribute('data-body-pane') !== key);
      });
      showForGender();
      applyHotspotPositions();
      setActive(currentIdx);
      closePanel();
    }

    Array.prototype.forEach.call(hotspots, function(spot) {
      spot.addEventListener('click', function() {
        openPanel(parseInt(spot.getAttribute('data-hotspot-trigger'), 10));
      });
    });
    Array.prototype.forEach.call(legendBtns, function(btn) {
      btn.addEventListener('click', function() {
        openPanel(parseInt(btn.getAttribute('data-hotspot-trigger'), 10));
      });
    });
    Array.prototype.forEach.call(bodyToggleBtns, function(btn) {
      btn.addEventListener('click', function() {
        switchBody(btn.getAttribute('data-body-switch'));
      });
    });
    if (panelCloseBtn) {
      panelCloseBtn.addEventListener('click', closePanel);
    }
    if (backdrop) {
      backdrop.addEventListener('click', closePanel);
    }

    var toastTimer;
    function showToast(msg) {
      if (!toast) return;
      toast.textContent = msg;
      toast.hidden = false;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function() { toast.hidden = true; }, 2400);
    }

    function activeData() {
      var card = panelCards[currentIdx];
      if (!card) return null;
      var dataEl = card.querySelector('[data-hotspot-data]');
      if (!dataEl) return null;
      try { return JSON.parse(dataEl.textContent); } catch (e) { return null; }
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-action="print"]'), function(btn) {
      btn.addEventListener('click', function() {
        var s = activeData();
        if (!s) return;
        var win = window.open('', '_blank', 'width=720,height=900');
        if (!win) return;
        var questions = (s.questions || '').split(/\n+/).filter(function(q) { return q.trim(); });
        var questionsHtml = questions.length
          ? '<ul>' + questions.map(function(q) { return '<li>' + q.replace(/</g, '&lt;') + '</li>'; }).join('') + '</ul>'
          : '<p><em>(No questions provided)</em></p>';
        var productList = (s.products || '').split(',').map(function(p) {
          return p.trim().replace(/-/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
        }).filter(Boolean).join(' · ');
        var html = '<!doctype html><html><head><title>Take this to your doctor - ' + (s.region || '') + '</title>'
          + '<style>'
          + 'body{font-family:Georgia,"Newsreader",serif;color:#1A1A14;max-width:640px;margin:32px auto;padding:0 32px;line-height:1.55}'
          + '.eyebrow{font-family:monospace;font-size:10px;letter-spacing:0.18em;text-transform:uppercase;color:#1A5F5B;margin-bottom:8px}'
          + 'h1{font-weight:400;font-size:32px;line-height:1.1;margin:0 0 8px;letter-spacing:-0.01em}'
          + 'h1 em{color:#1A5F5B}'
          + '.sub{font-family:monospace;font-size:11px;letter-spacing:0.12em;text-transform:uppercase;color:#7A746A;margin-bottom:24px}'
          + '.stat{padding:18px 0;border-top:1px solid #D8CFBC;border-bottom:1px solid #D8CFBC;display:flex;gap:16px;align-items:center}'
          + '.stat-num{font-size:44px;line-height:1;color:#1A5F5B}.stat-label{font-size:14px}'
          + 'h2{font-weight:500;font-size:17px;margin:32px 0 10px}'
          + 'ul{padding-left:22px;margin:0 0 16px}li{margin-bottom:8px;font-size:14px}'
          + '.meta{margin-top:32px;padding-top:16px;border-top:1px solid #D8CFBC;font-family:monospace;font-size:10px;letter-spacing:0.12em;text-transform:uppercase;color:#7A746A}'
          + '.brand{margin-bottom:24px;font-family:monospace;font-size:10px;letter-spacing:0.2em;text-transform:uppercase;color:#1A5F5B}'
          + '@media print{body{margin:0;padding:24px}}'
          + '</style></head><body>'
          + '<div class="brand">Roots Nutrition · Minority Health Reference</div>'
          + '<div class="eyebrow">' + (s.region || '') + '</div>'
          + '<h1>' + (s.title_lead || '') + (s.title_em ? ' <em>' + s.title_em + '</em>' : '') + '</h1>'
          + (s.sub ? '<div class="sub">' + s.sub + '</div>' : '')
          + (s.stat_num ? '<div class="stat"><div class="stat-num">' + s.stat_num + '</div><div class="stat-label">' + (s.stat_label || '') + '</div></div>' : '')
          + (s.body ? '<p style="font-style:italic;color:#4A463E">' + s.body + '</p>' : '')
          + '<h2>Questions to ask your doctor</h2>' + questionsHtml
          + (productList ? '<h2>Roots formulas that support this</h2><p>' + productList + '</p>' : '')
          + '<div class="meta">' + (s.source ? 'Source · ' + s.source + ' · ' : '') + 'Generated from rootsnutrition.com/pages/minority-health</div>'
          + '<scr' + 'ipt>setTimeout(function(){window.print();},400);</scr' + 'ipt>'
          + '</body></html>';
        win.document.write(html);
        win.document.close();
      });
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-action="share"]'), function(btn) {
      btn.addEventListener('click', function() {
        var s = activeData();
        if (!s) return;
        var slug = s.slug || (s.region || '').toLowerCase().replace(/[^a-z]+/g, '-');
        var url = window.location.origin + window.location.pathname + '#' + slug;
        var data = {
          title: (s.region || '') + ' — Roots Nutrition Minority Health',
          text: (s.title_lead || '') + ' ' + (s.title_em || '') + (s.stat_num ? ' — ' + s.stat_num + ' ' + (s.stat_label || '') : ''),
          url: url
        };
        if (navigator.share) {
          navigator.share(data).catch(function() {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function() {
            showToast('Link copied');
          }).catch(function() { showToast('Could not copy link'); });
        } else {
          showToast(url);
        }
      });
    });

    if (window.location.hash) {
      var hash = window.location.hash.replace('#', '');
      var match = -1;
      Array.prototype.forEach.call(panelCards, function(c, i) {
        if (c.getAttribute('data-slug') === hash) match = i;
      });
      if (match >= 0) {
        var g = panelCards[match].getAttribute('data-gender');
        if (g === 'man' || g === 'woman') currentBody = g;
        currentIdx = match;
      }
    }

    switchBody(currentBody);
    setActive(currentIdx);
  }

  function boot() {
    document.querySelectorAll('[data-anatomy-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-run on Shopify section reload in theme customizer
  document.addEventListener('shopify:section:load', boot);
})();
